import { ActionIcon, Tooltip } from '@mantine/core';
import { Icon, variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { InputContext } from 'app/modules/wallforming/components/input-binding/types/inputContext';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface ArticleToolsProps {
    menuOpened: boolean;
}

const screenWidth = window.screen.width;

export const ArticleTools = ({ menuOpened }: ArticleToolsProps) => {
    const { t } = useTranslation();
    const {
        arePivotControlsActive,
        isPanelQuickReplacementOpen,
        selectInputContext
    } = usePlacementStore(
        useShallow((state) => {
            return {
                arePivotControlsActive: state.arePivotControlsActive,
                isPanelQuickReplacementOpen: state.isPanelQuickReplacementOpen,
                selectInputContext: state.selectInputContext
            };
        })
    );
    return (
        <>
            <Tooltip disabled={menuOpened} label={t('transform')} position="right" variant={variants.tooltip.right}>
                <ActionIcon
                    aria-label={t('transform')}
                    aria-pressed={arePivotControlsActive}
                    className={`
                        bg-background-gray-ultra-light hover:bg-background-gray! pointer-events-auto
                        ${screenWidth >= 1920 ? 'action-icon-large' : 'action-icon-medium'}
                    `}
                    variant={arePivotControlsActive ? variants.actionIcon.activated : undefined}
                    onClick={() =>
                        selectInputContext(arePivotControlsActive ? InputContext.Placement : InputContext.Transformation)
                    }
                >
                    transform
                </ActionIcon>
            </Tooltip>
            <Tooltip
                disabled={menuOpened}
                label={t('labelInputActionPanelQuickReplacement')}
                position="right"
                variant={variants.tooltip.right}
            >
                <ActionIcon
                    aria-label={t('labelInputActionPanelQuickReplacement')}
                    aria-pressed={isPanelQuickReplacementOpen}
                    className={`
                        bg-background-gray-ultra-light hover:bg-background-gray! pointer-events-auto
                        ${screenWidth >= 1920 ? 'action-icon-large' : 'action-icon-medium'}
                    `}
                    variant={isPanelQuickReplacementOpen ? variants.actionIcon.activated : undefined}
                    onClick={() => {
                        selectInputContext(
                            isPanelQuickReplacementOpen ? InputContext.Placement : InputContext.Configuration
                        );
                    }}
                >
                    <Icon aria-hidden="true" icon="change_circle" size="xl" />
                </ActionIcon>
            </Tooltip>
        </>
    );
};